import { ResType, UrlPaths } from "@fanka/openapi-typescript";
import { appApiClient } from "@on-site/libs/appApiClient";
import { AppApiSwrGetOptions } from "@on-site/libs/swr/type";
import useSWR from "swr";

export const useAppApiSWR = <TEndpoint extends UrlPaths>(
  endpoint: TEndpoint,
  options?: AppApiSwrGetOptions<TEndpoint>,
) => {
  return useSWR<ResType<TEndpoint, "get">>(
    options?.enabled === false ? null : { endpoint, params: options?.params },
    async ({ endpoint }: { endpoint: TEndpoint }) => {
      const request = await appApiClient.get(endpoint, options);
      return request.data;
    },
    {
      refreshInterval: 1000 * 60 * 5,
      ...options,
    },
  );
};
